import { render, staticRenderFns } from "./AuthenticityRecord.vue?vue&type=template&id=557b2068&scoped=true&"
import script from "./AuthenticityRecord.vue?vue&type=script&lang=js&"
export * from "./AuthenticityRecord.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticityRecord.vue?vue&type=style&index=0&id=557b2068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b2068",
  null
  
)

export default component.exports